/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * Content management API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { PaginatedProfileList } from './';
import {
    PaginatedProfileListFromJSON,
    PaginatedProfileListFromJSONTyped,
    PaginatedProfileListToJSON,
} from './';

/**
 * 
 * @export
 * @interface AllFreelancersResponse
 */
export interface AllFreelancersResponse {
    /**
     * 
     * @type {PaginatedProfileList}
     * @memberof AllFreelancersResponse
     */
    profileList: PaginatedProfileList;
}

/**
 * Check if a given object implements the AllFreelancersResponse interface.
 */
export function instanceOfAllFreelancersResponse(value: object): value is AllFreelancersResponse {
    if (!('profileList' in value) || value['profileList'] === undefined) return false;
    return true;
}

export function AllFreelancersResponseFromJSON(json: any): AllFreelancersResponse {
    return AllFreelancersResponseFromJSONTyped(json, false);
}

export function AllFreelancersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AllFreelancersResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'profileList': PaginatedProfileListFromJSON(json['profileList']),
    };
}

export function AllFreelancersResponseToJSON(value?: AllFreelancersResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'profileList': PaginatedProfileListToJSON(value['profileList']),
    };
}

